import React, { useState } from "react";
import { Modal, Button, Form, Col, Row, Spinner, Alert } from "react-bootstrap";
import AuthHelper from "../../helpers/AuthHelper";
import { DANGER, EMPTY } from "../../configurations/Constants";
import {
  CONFIRM_ACCOUNT_BEFORE_LOGIN,
  ENTER_VERIFICATION_CODE,
  ENTER_VERIFICATION_CODE_RECEIVED,
  ERROR_CREATING_USER,
  ERROR_RESENDING_CODE_FOR_USER,
  ERROR_TRY_AFTER_SOMETIME,
  INVALID_CREDENTIALS,
  INVALID_VERIFICATION_CODE,
  RESEND_VERIFICATION_CODE,
} from "../../configurations/MessageConstants";

function VerificationPopup(props) {
  const [verificationCode, setVerificationCode] = useState(EMPTY);
  const [btnConfirmClick, setBtnConfirmClick] = useState(false);
  const [AuthError, setAuthError] = useState(false);
  const [verificationCodeError, setVerificationCodeError] = useState(false);
  const [verificationResending, setVerificationResending] = useState(false);
  const [errorMessage, setErrorMessage] = useState(INVALID_CREDENTIALS);

  const checkVerificationCode = (e) => {
    e.persist();
    setVerificationCode(e.target.value);
    setVerificationCodeError(false);
    if (e.target.value === EMPTY) {
      setVerificationCodeError(true);
    }
  };

  const handleResendCode = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    setVerificationResending(true);
    try {
      await AuthHelper.resendSignUp(props.userEmail);
      setVerificationResending(false);
    } catch (error) {
      console.error(ERROR_RESENDING_CODE_FOR_USER, error);
      setVerificationResending(false);
    }
  };

  const confirmSignUp = async (event) => {
    setBtnConfirmClick(true);
    event.preventDefault();
    event.stopPropagation();
    setVerificationCodeError(false);
    if (verificationCode !== EMPTY) {
      const username = props.userEmail;
      try {
        await AuthHelper.confirmSignUp(username, verificationCode);
        props.afterVerify();
      } catch (error) {
        setVerificationCodeError(true);
        setErrorMessage(INVALID_VERIFICATION_CODE);
        setBtnConfirmClick(false);
        console.error(ERROR_CREATING_USER, error);
      }
    } else {
      setBtnConfirmClick(false);
      setVerificationCodeError(true);
      setErrorMessage(ENTER_VERIFICATION_CODE);
    }
  };

  const closeModal = () => {};
  return (
    <Modal
      show={props.showVerificationPopup}
      onHide={closeModal}
      className="confirm-modal"
    >
      <Modal.Header>
        <h3>Enter Verification Code</h3>
      </Modal.Header>
      <Modal.Body>
        {AuthError && (
          <Alert
            variant={DANGER}
            onClose={() => setAuthError(false)}
            dismissible
          >
            {ERROR_TRY_AFTER_SOMETIME}
          </Alert>
        )}
        <p color="muted">{CONFIRM_ACCOUNT_BEFORE_LOGIN}</p>
        <Form noValidate validated={false}>
          <div>
            <Row>
              <Form.Group
                as={Col}
                md="12"
                controlId="validationMobileVerificationCode"
              >
                <Form.Label>Verification Code</Form.Label>
                <Form.Control
                  type="text"
                  name="verificationCode"
                  onChange={(e) => {
                    checkVerificationCode(e);
                  }}
                  value={verificationCode || EMPTY}
                  className={
                    verificationCodeError
                      ? "is-invalid invalidcontrol"
                      : verificationCode !== EMPTY
                      ? "is-valid"
                      : EMPTY
                  }
                />
                <Form.Control.Feedback type="invalid">
                  {errorMessage}
                </Form.Control.Feedback>
                <small className="resend-link">
                  {verificationResending === true ? (
                    <div>
                      <Spinner
                        as="div"
                        animation="grow"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />{" "}
                      <span> Sending</span>
                    </div>
                  ) : (
                    <Button
                      variant="link"
                      className="resend-link p-0 btn-link-small"
                      onClick={(e) => {
                        handleResendCode(e);
                      }}
                    >
                      {RESEND_VERIFICATION_CODE}
                    </Button>
                  )}
                </small>
              </Form.Group>
            </Row>
            <p className="text-muted">{ENTER_VERIFICATION_CODE_RECEIVED}</p>
          </div>
          <Button
            disabled={btnConfirmClick}
            type="button"
            onClick={(e) => confirmSignUp(e)}
          >
            {btnConfirmClick ? (
              <div>
                <Spinner
                  as="span"
                  animation="grow"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />{" "}
                <span>Verifying</span>
              </div>
            ) : (
              "Confirm Account"
            )}
          </Button>{" "}
          <Button
            type="button"
            onClick={(e) => {
              props.closeModal();
            }}
          >
            Close
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  );
}

export default VerificationPopup;
